/* Sends announcement and promo-countdown interactions to a dedicated GA4 event-only tag. */
(function () {
  'use strict';

  var measurementId = 'G-1WF8TNC6CC';
  var ga4LayerName = 'tufinaAnnouncementGa4Layer';
  var trackedViews = new WeakSet();

  window[ga4LayerName] = window[ga4LayerName] || [];

  function ga4() {
    window[ga4LayerName].push(arguments);
  }

  function loadGA4() {
    if (window.__tufinaAnnouncementGA4Loaded) return;
    window.__tufinaAnnouncementGA4Loaded = true;

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId) + '&l=' + encodeURIComponent(ga4LayerName);
    script.addEventListener('error', function () {
      if (window.console && typeof window.console.error === 'function') {
        window.console.error('[Tufina announcement tracking] GA4 script failed to load');
      }
    });
    document.head.appendChild(script);

    ga4('js', new Date());
    ga4('config', measurementId, {
      send_page_view: false
    });
  }

  function value(element, name) {
    return element && element.dataset ? (element.dataset[name] || '') : '';
  }

  function context(component) {
    return {
      page_type: value(component, 'trackingPageType'),
      page_path: value(component, 'trackingPagePath') || window.location.pathname,
      page_url: window.location.href,
      product_id: value(component, 'trackingProductId'),
      product_handle: value(component, 'trackingProductHandle'),
      product_title: value(component, 'trackingProductTitle'),
      collection_handle: value(component, 'trackingCollectionHandle'),
      collection_title: value(component, 'trackingCollectionTitle')
    };
  }

  function send(eventName, component, details) {
    var eventData = Object.assign({
      event_name: eventName,
      tracking_component: value(component, 'trackingComponent'),
      announcement_tracking_id: value(component, 'trackingId'),
      promo_text: value(component, 'trackingPromoText')
    }, context(component), details || {});

    window.__tufinaAnnouncementTrackingEvents = window.__tufinaAnnouncementTrackingEvents || [];
    window.__tufinaAnnouncementTrackingEvents.push(eventData);

    var ga4EventData = Object.assign({}, eventData);
    delete ga4EventData.event_name;
    ga4EventData.page_location = ga4EventData.page_url || window.location.href;
    ga4EventData.transport_type = 'beacon';
    ga4EventData.send_to = measurementId;
    ga4('event', eventName, ga4EventData);

    if (window.console && typeof window.console.info === 'function') {
      window.console.info('[Tufina announcement tracking]', eventName, eventData, {
        ga4_measurement_id: measurementId,
        ga4_event_queued: true
      });
    }
  }

  function isVisible(element) {
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function observeView(element, component, eventName, details) {
    if (!element || trackedViews.has(element)) return;

    function record() {
      if (trackedViews.has(element) || !isVisible(element)) return;
      trackedViews.add(element);
      send(eventName, component, details);
    }

    if (!('IntersectionObserver' in window)) {
      window.setTimeout(record, 0);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          record();
          observer.unobserve(element);
        }
      });
    }, { threshold: 0.01 });
    observer.observe(element);
  }

  function init() {
    document.querySelectorAll('[data-tracking-component="announcement_bar"]').forEach(function (bar) {
      bar.querySelectorAll('[data-tracking-item="announcement"]').forEach(function (slide) {
        observeView(slide, bar, 'announcement_bar_view', {
          announcement_id: value(slide, 'trackingId'),
          announcement_message: value(slide, 'trackingMessage')
        });
      });
    });

    document.querySelectorAll('[data-tracking-component="promo_countdown"]').forEach(function (promo) {
      observeView(promo, promo, 'announcement_promo_view', {
        promo_code: value(promo, 'discountCode'),
        cta_action: value(promo, 'codeAction'),
        product_variant_id: value(promo, 'addProductVariantId')
      });
    });

    document.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-tracking-cta="announcement_bar"]');
      if (!cta) return;
      var bar = cta.closest('[data-tracking-component="announcement_bar"]');
      var slide = cta.closest('[data-tracking-item="announcement"]');
      if (!bar || !slide) return;
      send('announcement_bar_click', bar, {
        announcement_id: value(slide, 'trackingId'),
        announcement_message: value(slide, 'trackingMessage'),
        cta_type: value(cta, 'trackingCtaType'),
        cta_label: value(cta, 'trackingCtaLabel'),
        cta_destination: value(cta, 'trackingDestination') || cta.href || ''
      });
    });

    document.addEventListener('tufina:announcement-tracking', function (event) {
      var promo = event.target.closest('[data-tracking-component="promo_countdown"]');
      if (!promo || !event.detail || !event.detail.event_name) return;
      send(event.detail.event_name, promo, event.detail);
    });
  }

  loadGA4();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
